import { FC } from "react"
import { Grid } from "@mui/material"
import { DataLoggerList, HasSidebarLayout, ListHeader, SearchForm } from "src/components"
import { useDataLoggerListRequest } from "src/hooks/api"
import { useQueryParams } from "src/hooks/ui"
import { defaultPage, defaultPerPage } from "src/config"

const initialQueryParams = {
  page: `${defaultPage}`,
  rowsPerPage: `${defaultPerPage}`,
}

const DataLoggerLoader: FC = () => {
  document.title = 'CLīMIT Admin Panel - DataPUCK list'
  const [queryParams, setQueryParams] = useQueryParams(initialQueryParams)
  const { data, isInitialLoading } = useDataLoggerListRequest({
    params: queryParams,
  })

  return (
    <HasSidebarLayout>
      <ListHeader title="DataPUCKs" />
      <Grid container direction="column" alignItems="stretch" spacing={2} sx={{ my: 2 }}>
        <Grid item>
          <SearchForm />
        </Grid>
      </Grid>
      <DataLoggerList
        dataLoggerCount={data?.count || 0}
        dataLoggers={data?.rows || []}
        isLoading={isInitialLoading}
        setQueryParams={setQueryParams}
        queryParams={queryParams}
        autoHeight={false}
      />
    </HasSidebarLayout>
  )
}

export default DataLoggerLoader